import { render } from "./MiniWizardItemsContent.vue?vue&type=template&id=613210e6"
import script from "./MiniWizardItemsContent.vue?vue&type=script&lang=js"
export * from "./MiniWizardItemsContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__